import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { IntegrationKind } from 'src/app/models/integration/integration';

// The `:type` URL segment (used by the integrations-list cards) maps onto an
// IntegrationKind. Each kind is rendered by its own page component.
const URL_TYPE_TO_KIND: Record<string, IntegrationKind | undefined> = {
  website: IntegrationKind.WEBSITE,
};

@Component({
  selector: 'app-integration',
  templateUrl: './integration.component.html',
  styleUrls: ['./integration.component.scss']
})
export class IntegrationComponent implements OnInit {
  kind?: IntegrationKind;

  protected readonly IntegrationKind = IntegrationKind;

  constructor(private readonly route: ActivatedRoute) {}

  async ngOnInit() {
    const params = await firstValueFrom(this.route.params);
    const urlType = String(params['type'] ?? '').toLowerCase();
    this.kind = URL_TYPE_TO_KIND[urlType];
  }
}
